import { render, staticRenderFns } from "./VipOpenModal.vue?vue&type=template&id=452ba60a&scoped=true"
import script from "./VipOpenModal.vue?vue&type=script&lang=js"
export * from "./VipOpenModal.vue?vue&type=script&lang=js"
import style0 from "./VipOpenModal.vue?vue&type=style&index=0&id=452ba60a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "452ba60a",
  null
  
)

export default component.exports